import { SET_BOM_FILES } from '../../constants/ActionConstants';

export const setBomFile = (file) => ({
    type: SET_BOM_FILES,
    data: { bomFile: file }
});